"use client";

import React from "react";
import Link from "next/link";

export const EventIntroSection = () => {
  return (
    <section className="flex w-full flex-col items-center justify-center bg-gradient-to-b from-white to-gray-50 px-4 py-20 ph:px-24 md:px-48 lg:px-72 xl:px-96">
      <div className="max-w-3xl text-center">
        <h2 className="font-cormorant text-4xl uppercase tracking-wide text-primary ph:text-5xl">
          Nos Événements Mensuels
        </h2>

        <p className="mx-auto mt-4 text-base text-gray-600">
          Découvrez chaque mois nos <strong>événements exclusifs</strong> et
          promotions spéciales dans l&apos;ensemble de nos salons{" "}
          <strong className="text-gold">Alexandra Grey</strong>.
        </p>
      </div>
    </section>
  );
};
